module.exports = __webpack_public_path__ + "static/media/PB_buildings_2.1161a2a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PB_buildings_2.png
// module id = 702
// module chunks = 0